"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1833],{

/***/ 3105:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "GarageProfileBooking": function() { return /* binding */ GarageProfileBooking; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(1799);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./store.ts
var store = __webpack_require__(7576);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(655);
// EXTERNAL MODULE: ./node_modules/react-calendar/dist/esm/index.js + 28 modules
var esm = __webpack_require__(5179);
// EXTERNAL MODULE: ./node_modules/react-calendar/dist/Calendar.css
var Calendar = __webpack_require__(9318);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/startOfMonth/index.js
var startOfMonth = __webpack_require__(3703);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/parseISO/index.js + 1 modules
var parseISO = __webpack_require__(8420);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/endOfMonth/index.js
var endOfMonth = __webpack_require__(4135);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/differenceInMonths/index.js + 3 modules
var differenceInMonths = __webpack_require__(338);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/addMonths/index.js
var addMonths = __webpack_require__(1640);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/isSameDay/index.js
var isSameDay = __webpack_require__(3151);
// EXTERNAL MODULE: ./hooks/useDates.ts
var useDates = __webpack_require__(6635);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useQuery.js + 1 modules
var useQuery = __webpack_require__(7887);
// EXTERNAL MODULE: ./graphql/queries/index.ts + 11 modules
var queries = __webpack_require__(3299);
;// CONCATENATED MODULE: ./hooks/useWindowFocus.ts

/**
 * Hook that returns whether the window is currently focused. Re-evaluates whenever the window's "is
 * focused" state changes.
 */ // Note: Inspired by https://github.com/jpalumickas/use-window-focus/blob/main/src/index.ts.
function useWindowFocus() {
    var ref = (0,react.useState)(hasFocus()), isWindowFocused = ref[0], setIsWindowFocused = ref[1]; // Focus for first render.
    (0,react.useEffect)(function() {
        setIsWindowFocused(hasFocus()); // Focus for following renders.
        var onFocus = function() {
            return setIsWindowFocused(true);
        };
        var onBlur = function() {
            return setIsWindowFocused(false);
        };
        window.addEventListener("focus", onFocus);
        window.addEventListener("blur", onBlur);
        return function() {
            window.removeEventListener("focus", onFocus);
            window.removeEventListener("blur", onBlur);
        };
    }, []);
    return {
        isWindowFocused: isWindowFocused
    };
}
function hasFocus() {
    return document.hasFocus();
}

;// CONCATENATED MODULE: ./hooks/useQueryPollingWhileWindowFocused.ts


/**
 * Hook that enables polling for a given GraphQL query while the window is focused - and disables
 * polling while the window is not focused. This reduces network traffic to our server while the
 * user isn't literally focused on our application.
 *
 * See the [Apollo docs](https://www.apollographql.com/docs/react/data/queries/#polling) for details
 * about polling.
 */ function useQueryPollingWhileWindowFocused(param) {
    var pollInterval = param.pollInterval, loading = param.loading, refetch = param.refetch, skip = param.skip, startPolling = param.startPolling, stopPolling = param.stopPolling;
    var isWindowFocused = useWindowFocus().isWindowFocused;
    (0,react.useEffect)(function() {
        if (!isWindowFocused || skip) {
            stopPolling();
        } else {
            // Refetch data immediately when the window is refocused.
            if (!loading) {
                refetch === null || refetch === void 0 ? void 0 : refetch();
            }
            startPolling(pollInterval);
        }
    }, [
        isWindowFocused,
        pollInterval,
        refetch,
        startPolling,
        stopPolling
    ]);
}

;// CONCATENATED MODULE: ./hooks/useCalculation.ts

var useCalculation = function() {
    var state = (0,store/* default */.Z)();
    var organization = state.order.organization;
    var service = state.order.service;
    var garage = state.order.garage;
    var filterBrand = state.filters.brandFilter;
    var brand = state.order.brand;
    var generation = state.order.generation;
    var motorization = state.order.motorization;
    var body = state.order.body;
    var gearbox = state.order.gearbox;
    var mileage = state.order.mileage;
    var initialRegistrationDate = state.order.initialRegistrationDate;
    var subRepairs = state.order.subRepairs;
    var equipments = state.order.equipments;
    var premiumServices = state.order.premiumServices;
    return {
        organization: organization,
        service: service,
        garage: garage,
        filterBrand: filterBrand,
        brand: brand,
        generation: generation,
        motorization: motorization,
        body: body,
        gearbox: gearbox,
        mileage: mileage,
        initialRegistrationDate: initialRegistrationDate,
        subRepairs: subRepairs,
        equipments: equipments,
        premiumServices: premiumServices
    };
};

;// CONCATENATED MODULE: ./hooks/useDays.ts






var useDays = function(from, to) {
    var ref = (0,useDates/* useDates */.A)(), formatDate = ref.formatDate, toIsoString = ref.toIsoString;
    var ref1 = useCalculation(), organization = ref1.organization, service = ref1.service, garage = ref1.garage, filterBrand = ref1.filterBrand, brand = ref1.brand, generation = ref1.generation, motorization = ref1.motorization, body = ref1.body, gearbox = ref1.gearbox, mileage = ref1.mileage, initialRegistrationDate = ref1.initialRegistrationDate, subRepairs = ref1.subRepairs, equipments = ref1.equipments, premiumServices = ref1.premiumServices;
    var ref2 = (0,useQuery/* useQuery */.a)(queries/* GET_GARAGE_DAYS */.ZY, {
        variables: {
            organization: organization ? organization.id : null,
            garage: garage ? garage.id : null,
            services: service ? [
                service.id
            ] : null,
            startDate: toIsoString(from),
            endDate: toIsoString(to),
            brand: brand ? brand.id : filterBrand ? filterBrand.id : null,
            generation: generation ? generation.id : null,
            motorization: motorization ? motorization.id : null,
            body: body ? body.id : null,
            gearbox: gearbox ? gearbox.id : null,
            mileage: mileage,
            // TODO: withCalculation: organization.settings.garage_list.display_prices ?? false,
            withCalculation: true,
            registrationDate: initialRegistrationDate ? formatDate(initialRegistrationDate, "yyyy-MM-dd") : null,
            premiumServices: premiumServices && premiumServices.length > 0 ? premiumServices.map(function(p) {
                return p.id;
            }) : null,
            equipments: equipments && equipments.map(function(equipment) {
                return equipment.name;
            }),
            subRepairs: subRepairs
        },
        skip: !organization || !garage || !service || !from || !to
    }), loading = ref2.loading, data = ref2.data, error = ref2.error, refetch = ref2.refetch, startPolling = ref2.startPolling, stopPolling = ref2.stopPolling, networkStatus = ref2.networkStatus;
    // only poll for new days if window is focused
    useQueryPollingWhileWindowFocused({
        pollInterval: 60000,
        loading: loading,
        refetch: refetch,
        skip: !organization || !garage || !service || !from || !to,
        startPolling: startPolling,
        stopPolling: stopPolling
    });
    return {
        loading: loading,
        error: error,
        networkStatus: networkStatus,
        days: data && data.garage.days ? data.garage.days.map(function(date) {
            return (0,parseISO/* default */.Z)(date);
        }) : [],
        nearestDay: data && data.garage.days ? data.garage.days[0] : null
    };
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(1438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(8029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(460);
;// CONCATENATED MODULE: ./components/common/Loader.tsx





var Loader = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(Loader, PureComponent);
    var _super = (0,_create_super/* default */.Z)(Loader);
    function Loader() {
        (0,_class_call_check/* default */.Z)(this, Loader);
        return _super.apply(this, arguments);
    }
    var _proto = Loader.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex justify-center items-center relative",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "animate-spin rounded-full ".concat(this.props.loaderSizeClass ? this.props.loaderSizeClass : "h-32 w-32", " border-b-2 border-primary")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "absolute",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                        className: "fak fa-repareo text-4xl text-gray-500"
                    })
                })
            ]
        });
    };
    return Loader;
}(react.PureComponent);

;// CONCATENATED MODULE: ./components/common/DayPicker/DayPicker.tsx










var DayPicker = function(props) {
    var state = (0,store/* default */.Z)();
    var garage = state.order.garage;
    var slot = state.order.slot;
    var ref = (0,react.useState)(garage && garage.available_days.length > 0 ? (0,startOfMonth/* default */.Z)((0,parseISO/* default */.Z)(garage.available_days[0].available_at.toString())) : (0,startOfMonth/* default */.Z)(new Date())), earliestStartDate = ref[0], setEarliestStartDate = ref[1];
    var ref1 = (0,react.useState)(slot ? (0,parseISO/* default */.Z)(slot.starts_at) : earliestStartDate), startDate = ref1[0];
    var ref2 = (0,react.useState)((0,startOfMonth/* default */.Z)(startDate)), from = ref2[0], setFrom = ref2[1];
    var ref3 = (0,react.useState)((0,endOfMonth/* default */.Z)(startDate)), to = ref3[0], setTo = ref3[1];
    var ref4 = (0,react.useState)(new Date()), activeStartDate = ref4[0], setActiveStartDate = ref4[1];
    var ref5 = (0,react.useState)(false), monthChanged = ref5[0], setMonthChanged = ref5[1];
    var ref6 = (0,react.useState)(false), userInputReceived = ref6[0], setUserInputReceived = ref6[1];
    var ref7 = useDays(from, to), loading = ref7.loading, days = ref7.days, error = ref7.error;
    (0,react.useEffect)(function() {
        if (props.nextSlot) {
            setEarliestStartDate((0,startOfMonth/* default */.Z)((0,parseISO/* default */.Z)(props.nextSlot.starts_at)));
        }
    }, [
        props.nextSlot
    ]);
    (0,react.useEffect)(function() {
        setActiveStartDate((0,startOfMonth/* default */.Z)(startDate));
    }, []);
    (0,react.useEffect)(function() {
        // select the first available day on initial load
        // if (!loading && !props.selectedDay && days) {
        //     props.onChange && props.onChange(days[0])
        // }
        // return if there are available days in the selected month
        if (days && !loading && props.onNoAvailableDays) {
            props.onNoAvailableDays(days.length > 0);
        }
        if (monthChanged && !loading && props.selectedDay && props.selectedDay.getMonth() !== activeStartDate.getMonth()) {
            props.onChange && props.onChange(days[0]);
            setMonthChanged(false);
        }
        if (!loading && !userInputReceived && days.length === 0 && (0,differenceInMonths/* default */.Z)(activeStartDate, new Date()) < 1) {
            onChangeMonth({
                "activeStartDate": (0,addMonths/* default */.Z)(activeStartDate, 1)
            });
        }
        props.daysLoading && props.daysLoading(loading);
    }, [
        loading,
        days,
        error
    ]);
    // if the picked date changed from an external source
    // reset the calendar to the right month
    (0,react.useEffect)(function() {
        if (props.selectedDay && days && days.length > 0 && props.selectedDay !== days[0]) {
            onChangeMonth({
                "activeStartDate": props.selectedDay
            });
            setMonthChanged(false);
        }
    }, [
        props.selectedDay
    ]);
    var changeDay = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(selectedDay) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                props.onChange(selectedDay);
                return [
                    2
                ];
            });
        });
        return function changeDay(selectedDay) {
            return _ref.apply(this, arguments);
        };
    }();
    var checkDay = function(day) {
        return !days.some(function(date) {
            return (0,isSameDay/* default */.Z)(date, day);
        });
    };
    var onChangeMonth = function(value) {
        setActiveStartDate(value.activeStartDate);
        setFrom((0,startOfMonth/* default */.Z)(value.activeStartDate));
        setTo((0,endOfMonth/* default */.Z)(value.activeStartDate));
        setMonthChanged(true);
        setUserInputReceived(true);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* default */.ZP, {
                onChange: changeDay,
                minDate: (0,startOfMonth/* default */.Z)(earliestStartDate),
                maxDate: (0,addMonths/* default */.Z)((0,endOfMonth/* default */.Z)(new Date()), 3),
                value: props.selectedDay && new Date(props.selectedDay),
                className: "\n                mt-3\n                border\n                border-1\n                border-gray-100\n                font-serif\n                p-3\n                w-full\n                md:w-96 h-full\n                ".concat(loading ? "animate-pulse opacity-90 blur-sm" : "", "\n                ").concat(props.className),
                tileDisabled: function(param) {
                    var date = param.date;
                    return checkDay(date);
                },
                minDetail: "month",
                locale: "de-DE",
                onActiveStartDateChange: onChangeMonth,
                activeStartDate: activeStartDate
            }),
            loading && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "absolute top-0 pt-8 text-2xl font-serif w-full text-center border border-1 border-gray-300 rounded-lg h-80",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "pb-6",
                        children: [
                            "Werkstattkalender ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            " wird geladen..."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader, {
                        loaderSizeClass: "w-24 h-24",
                        logoSizeClass: "w-12 h-12"
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/date-fns/esm/startOfDay/index.js
var startOfDay = __webpack_require__(9119);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/endOfDay/index.js
var endOfDay = __webpack_require__(3894);
;// CONCATENATED MODULE: ./hooks/useSlots.ts







var useSlots = function(date) {
    var ref = (0,useDates/* useDates */.A)(), formatDate = ref.formatDate, toIsoString = ref.toIsoString;
    var state = (0,store/* default */.Z)();
    var slot = state.order.slot;
    var ref1 = useCalculation(), organization = ref1.organization, service = ref1.service, garage = ref1.garage, filterBrand = ref1.filterBrand, brand = ref1.brand, generation = ref1.generation, motorization = ref1.motorization, body = ref1.body, gearbox = ref1.gearbox, mileage = ref1.mileage, initialRegistrationDate = ref1.initialRegistrationDate, subRepairs = ref1.subRepairs, equipments = ref1.equipments, premiumServices = ref1.premiumServices;
    var ref2 = (0,useQuery/* useQuery */.a)(queries/* GET_GARAGE_SLOTS */.Yv, {
        variables: {
            organization: organization ? organization.id : null,
            garage: garage ? garage.id : null,
            services: service ? [
                service.id
            ] : null,
            from: date ? toIsoString((0,startOfDay/* default */.Z)(date)) : null,
            to: date ? toIsoString((0,endOfDay/* default */.Z)(date)) : null,
            brand: brand ? brand.id : filterBrand ? filterBrand.id : null,
            generation: generation ? generation.id : null,
            motorization: motorization ? motorization.id : null,
            body: body ? body.id : null,
            gearbox: gearbox ? gearbox.id : null,
            mileage: mileage,
            //TODO: withCalculation: organization.settings.garage_list.display_prices ?? false,
            withCalculation: true,
            registrationDate: initialRegistrationDate ? formatDate(initialRegistrationDate, "yyyy-MM-dd") : null,
            premiumServices: premiumServices && premiumServices.length > 0 ? premiumServices.map(function(p) {
                return p.id;
            }) : null,
            equipments: equipments && equipments.map(function(equipment) {
                return equipment.name;
            }),
            subRepairs: subRepairs,
            session_id: slot && slot.session_id ? slot.session_id : null
        },
        skip: !organization || !garage || !date
    }), loading = ref2.loading, data = ref2.data, error = ref2.error, refetch = ref2.refetch, startPolling = ref2.startPolling, stopPolling = ref2.stopPolling;
    // only poll for new days if window is focused
    useQueryPollingWhileWindowFocused({
        pollInterval: 60000,
        loading: loading,
        skip: !organization || !garage || !date,
        refetch: refetch,
        startPolling: startPolling,
        stopPolling: stopPolling
    });
    return {
        loading: loading,
        error: error,
        slots: data ? data.garage.slots : [],
        nextSlot: data && data.garage.earliestSlot ? data.garage.earliestSlot : null
    };
};

// EXTERNAL MODULE: ./node_modules/@eo-locale/react/lib/index.js + 1 modules
var lib = __webpack_require__(7245);
;// CONCATENATED MODULE: ./components/common/TimeSlotPicker.tsx







var TimeSlotPicker = function(props) {
    var ref = useSlots(props.day), loading = ref.loading, nextSlot = ref.nextSlot, slots = ref.slots, error = ref.error;
    (0,react.useEffect)(function() {
        if (slots && slots.length > 0 && !props.selectedSlot) {
            props.onChange(slots[0]);
        }
        if (slots && slots.length > 0 && props.selectedSlot && !(0,isSameDay/* default */.Z)((0,parseISO/* default */.Z)(props.selectedSlot.starts_at), (0,parseISO/* default */.Z)(slots[0].starts_at))) {
            props.onChange(slots[0]);
        }
        nextSlot && props.onChangeEarliestSlot && props.onChangeEarliestSlot(nextSlot);
    }, [
        loading,
        slots,
        nextSlot,
        error
    ]);
    if (error) {
    //console.log(error)
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative max-h-[250px]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "\n                max-h-[240px]\n                flex flex-col\n                sm:text-sm\n                bg-white\n                border border-gray-300 rounded-lg\n                p-3\n                w-full\n            ".concat(loading || props.daysLoading ? "blur-sm animate-pulse opacity-90" : ""),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "Verf\xfcgbare Abgabezeit"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "grid grid-cols-2 gap-2 mt-3 overflow-y-auto no-scrollbar",
                        children: [
                            error && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* Text */.xv, {
                                    id: "error"
                                })
                            }),
                            (loading || props.daysLoading) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "w-full rounded border opacity-50 h-7 rounded-md"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "w-full rounded border opacity-50 h-7 rounded-md"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "w-full rounded border opacity-50 h-7 rounded-md"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "w-full rounded border opacity-50 h-7 rounded-md"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "w-full rounded border opacity-50 h-7 rounded-md"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "w-full rounded border opacity-50 h-7 rounded-md"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "w-full rounded border opacity-50 h-7 rounded-md"
                                    })
                                ]
                            }),
                            !loading && !props.daysLoading && !error && props.selectedSlot && slots && slots.length > 0 && slots.map(function(slot) {
                                var ref;
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)("span", {
                                    className: "\n                        text-center hover:text-white\n                        rounded\n                        py-1 px-3\n                        hover:bg-primary-200\n                        cursor-pointer\n                        border hover:border-primary\n                        ".concat(slot.starts_at === ((ref = props.selectedSlot) === null || ref === void 0 ? void 0 : ref.starts_at) ? "bg-primary border-primary text-white" : "text-primary border-gray-400"),
                                    onClick: function() {
                                        return props.onChange(slot);
                                    },
                                    children: slot.starts_at.slice(11, 16)
                                }, slot.starts_at);
                            })
                        ]
                    })
                ]
            }),
            (loading || props.daysLoading) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute top-1/3 text-2xl font-serif text-center w-full",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader, {
                    loaderSizeClass: "w-24 h-24",
                    logoSizeClass: "w-12 h-12"
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useMutation.js
var useMutation = __webpack_require__(319);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 10 modules
var graphql_tag_lib = __webpack_require__(7283);
;// CONCATENATED MODULE: ./graphql/mutations/unblockSlot.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    mutation UnblockSlot($slot: ID!, $calendar: ID!) {\n        unblock(\n            slot: $slot,\n            calendar: $calendar\n        )\n    }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var UNBLOCK_SLOT = (0,graphql_tag_lib/* gql */.Ps)(_templateObject());

;// CONCATENATED MODULE: ./hooks/graphql/mutations/useUnblockSlot.ts




var useUnblockSlot = function() {
    var ref = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(UNBLOCK_SLOT), 2), unblock = ref[0], ref1 = ref[1], loading = ref1.loading, data = ref1.data, error = ref1.error;
    var state = (0,store/* default */.Z)();
    var unblockSlot = function(slot) {
        unblock({
            variables: {
                slot: slot.id,
                calendar: slot.calendar_id
            }
        });
        // reset id
        slot.id = undefined;
        state.setSlot(slot);
    };
    return {
        error: error,
        loading: loading,
        unblockSlot: unblockSlot,
        successful: data ? data.unblock : null
    };
};

;// CONCATENATED MODULE: ./hooks/useUnblockSlotOnMount.ts



var useUnblockSlotOnMount = function() {
    var state = (0,store/* default */.Z)();
    var slot = state.order.slot;
    var ref = useUnblockSlot(), unblockSlot = ref.unblockSlot, loading = ref.loading, successful = ref.successful;
    (0,react.useEffect)(function() {
        if (slot && slot.id) {
            unblockSlot(slot);
        }
    }, []);
    return {
        successfullyUnblockedSlot: !slot || !loading && successful
    };
};

;// CONCATENATED MODULE: ./graphql/mutations/blockSlot.ts

function blockSlot_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    mutation BlockSlot(\n        $organization: ID!,\n        $garage: ID!,\n        $calendarId: ID!\n        $services: [ID]!,\n        $startDate: DateTimeTz!,\n        $endDate: DateTimeTz!,\n        $brand: ID,\n        $generation: ID,\n        $motorization: ID,\n        $gearbox: ID,\n        $body: ID,\n        $mileage: Int,\n        $registrationDate: Date,\n        $subRepairs: [String],\n        $equipments: [String],\n        $premiumServices: [ID]) {\n        block(\n            input: {\n                organization: $organization,\n                from: $startDate,\n                to: $endDate,\n                duration: 30\n                garage: $garage,\n                calendar: $calendarId\n                calculation: {\n                    services: $services\n                    brand: $brand\n                    generation: $generation\n                    motorization: $motorization\n                    mileage: $mileage\n                    gearbox: $gearbox\n                    body: $body\n                    registration_date: $registrationDate\n                    sub_repairs: $subRepairs\n                    equipments: $equipments\n                    premiumServices: $premiumServices\n                }\n            }\n        ) {\n            id\n            starts_at\n            ends_at\n            blocked_at\n            calendar_id\n            session_id\n        }\n    }\n"
    ]);
    blockSlot_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var BLOCK_SLOT = (0,graphql_tag_lib/* gql */.Ps)(blockSlot_templateObject());

;// CONCATENATED MODULE: ./hooks/graphql/mutations/useBlockSlot.ts






var useBlockSlot = function() {
    var ref = useCalculation(), organization = ref.organization, service = ref.service, garage = ref.garage, filterBrand = ref.filterBrand, brand = ref.brand, generation = ref.generation, motorization = ref.motorization, body = ref.body, gearbox = ref.gearbox, mileage = ref.mileage, initialRegistrationDate = ref.initialRegistrationDate, subRepairs = ref.subRepairs, equipments = ref.equipments, premiumServices = ref.premiumServices;
    var ref1 = (0,react.useState)(null), triedSlot = ref1[0], setTriedSlot = ref1[1];
    var ref2 = (0,useDates/* useDates */.A)(), toIsoString = ref2.toIsoString, formatDate = ref2.formatDate;
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)(BLOCK_SLOT), 2), block = ref3[0], ref4 = ref3[1], loading = ref4.loading, data = ref4.data, error = ref4.error;
    var blockSlot = function(slot) {
        setTriedSlot(slot);
        block({
            variables: {
                organization: organization ? organization.id : null,
                garage: garage ? garage.id : null,
                calendarId: slot.calendar_id,
                services: service ? [
                    service.id
                ] : null,
                startDate: slot ? toIsoString(slot.starts_at) : null,
                endDate: slot && slot.ends_at ? toIsoString(slot.ends_at) : null,
                brand: brand ? brand.id : filterBrand ? filterBrand.id : null,
                generation: generation ? generation.id : null,
                motorization: motorization ? motorization.id : null,
                body: body ? body.id : null,
                gearbox: gearbox ? gearbox.id : null,
                mileage: mileage,
                // TODO: withCalculation: organization.settings.garage_list.display_prices ?? false,
                withCalculation: true,
                registrationDate: initialRegistrationDate ? formatDate(initialRegistrationDate, "yyyy-MM-dd") : null,
                premiumServices: premiumServices && premiumServices.length > 0 ? premiumServices.map(function(p) {
                    return p.id;
                }) : null,
                equipments: equipments && equipments.map(function(equipment) {
                    return equipment.name;
                }),
                subRepairs: subRepairs,
                session_id: slot && slot.session_id ? slot.session_id : null
            }
        });
    };
    return {
        error: error,
        loading: loading,
        triedSlot: triedSlot,
        blockedSlot: data ? data.block : null,
        blockSlot: blockSlot
    };
};

;// CONCATENATED MODULE: ./hooks/useBooking.ts





var useBooking = function() {
    // unblock a blocked slot, if the user already clicked and blocked a
    // slot in this session
    useUnblockSlotOnMount();
    // block slot graphql api hook for slot reservation
    var ref = useBlockSlot(), triedSlot = ref.triedSlot, blockSlot = ref.blockSlot, errorWhenBlockingSlot = ref.error, loadingWhenBlockingSlot = ref.loading, blockedSlot = ref.blockedSlot;
    var state = (0,store/* default */.Z)();
    var ref1 = (0,react.useState)(state.order.slot ? (0,startOfDay/* default */.Z)((0,parseISO/* default */.Z)(state.order.slot.starts_at)) : null), selectedDay = ref1[0], setSelectedDay = ref1[1];
    var ref2 = (0,react.useState)(true), daysAvailable = ref2[0], setDaysAvailable = ref2[1];
    var ref3 = (0,react.useState)(null), nextSlot = ref3[0], setNextSlot = ref3[1];
    var ref4 = (0,react.useState)(null), initiallySelectedDay = ref4[0], setInitiallySelectedDay = ref4[1];
    var ref5 = (0,react.useState)(false), isShowingServices = ref5[0], setIsShowingServices = ref5[1];
    var ref6 = (0,react.useState)(true), isShowingCalendar = ref6[0], setIsShowingCalendar = ref6[1];
    var ref7 = (0,react.useState)(false), daysLoading = ref7[0], setDaysLoading = ref7[1];
    var selectedSlot = state.order.slot;
    var changeDay = function(day) {
        if (!initiallySelectedDay) {
            setInitiallySelectedDay(day);
        }
        setSelectedDay(day);
    };
    var changeSlot = function(slot) {
        state.setSlot(slot);
        if (selectedSlot && selectedSlot !== nextSlot) {
            setIsShowingCalendar(false);
        }
    };
    var changeEarliestSlot = function(slot) {
        setNextSlot(slot);
    };
    var selectFirstSlot = function() {
        if (nextSlot) {
            setSelectedDay((0,startOfDay/* default */.Z)((0,parseISO/* default */.Z)(nextSlot.starts_at)));
            state.setSlot(nextSlot);
        }
    };
    var submit = function() {
        selectedSlot && blockSlot(selectedSlot);
    };
    return {
        changeDay: changeDay,
        daysAvailable: daysAvailable,
        setDaysAvailable: setDaysAvailable,
        setDaysLoading: setDaysLoading,
        errorWhenBlockingSlot: errorWhenBlockingSlot,
        loadingWhenBlockingSlot: loadingWhenBlockingSlot,
        selectFirstSlot: selectFirstSlot,
        triedSlot: triedSlot,
        nextSlot: nextSlot,
        initiallySelectedDay: initiallySelectedDay,
        selectedDay: selectedDay,
        isShowingServices: isShowingServices,
        setIsShowingServices: setIsShowingServices,
        isShowingCalendar: isShowingCalendar,
        setIsShowingCalendar: setIsShowingCalendar,
        selectedSlot: selectedSlot,
        daysLoading: daysLoading,
        changeSlot: changeSlot,
        changeEarliestSlot: changeEarliestSlot,
        blockSlot: blockSlot,
        blockedSlot: blockedSlot,
        submit: submit
    };
};

// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/transitions/transition.js + 18 modules
var transition = __webpack_require__(4463);
;// CONCATENATED MODULE: ./components/common/Alert.tsx



var Alert = function(props) {
    var classNames = props.classNames, title = props.title, display = props.display, duration = props.duration;
    var ref = (0,react.useState)(display), show = ref[0], setShow = ref[1];
    (0,react.useEffect)(function() {
        if (display != show) {
            setShow(display);
        }
        if (!duration) {
            return;
        }
        var timer = setTimeout(function() {
            setShow(false);
        }, duration);
        return function() {
            return duration > 0 && clearTimeout(timer);
        };
    }, [
        display
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition */.u, {
        show: show,
        enter: "transition-opacity duration-75",
        enterFrom: "opacity-0",
        enterTo: "opacity-100",
        leave: "transition-opacity duration-100",
        leaveFrom: "opacity-100",
        leaveTo: "opacity-0",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "".concat(classNames, " bg-warning rounded my-2 p-3"),
            children: title
        })
    });
};

// EXTERNAL MODULE: ./components/common/FormElements/SelectDropdown.tsx
var SelectDropdown = __webpack_require__(7998);
// EXTERNAL MODULE: ./hooks/useVehicletree.ts + 1 modules
var useVehicletree = __webpack_require__(2477);
// EXTERNAL MODULE: ./hooks/graphql/queries/useServices.ts
var useServices = __webpack_require__(8077);
// EXTERNAL MODULE: ./components/common/ListButton.tsx
var ListButton = __webpack_require__(5397);
// EXTERNAL MODULE: ./components/Skeletons/FilterSkeleton.tsx
var FilterSkeleton = __webpack_require__(1888);
// EXTERNAL MODULE: ./components/common/FormElements/GenerationSelectDropdown.tsx
var GenerationSelectDropdown = __webpack_require__(4449);
// EXTERNAL MODULE: ./components/common/FormElements/MotorizationSelectDropdown.tsx
var MotorizationSelectDropdown = __webpack_require__(2202);
;// CONCATENATED MODULE: ./components/GarageProfile/GaragProfileParts/GarageProfileBooking.tsx




















var GarageProfileBooking = /*#__PURE__*/ react.memo(function(param) {
    var garage = param.garage, id = param.id, brands = param.brands, className = param.className, partner = param.partner, onSubmit = param.onSubmit;
    var ref, ref1, ref2, ref3;
    var state = (0,store/* default */.Z)();
    var router = (0,next_router.useRouter)();
    var formatDate = (0,useDates/* useDates */.A)().formatDate;
    var service = state.order.service;
    var place = state.order.place;
    var brand = state.order.brand;
    var organization = state.order.organization;
    var generation = state.order.generation;
    var motorization = state.order.motorization;
    var gearbox = state.order.gearbox;
    var body = state.order.body;
    var ref4 = (0,useVehicletree/* useVehicletree */.p)(), generations = ref4.generations, motorizations = ref4.motorizations, loading = ref4.loading;
    var services = (0,useServices/* useServices */.S)(partner.id).services;
    (0,react.useEffect)(function() {
        var queryParams = new URLSearchParams(window.location.search);
        if (queryParams.size !== 0 && queryParams.get("service") && services) {
            var serviceFromUrl = services.filter(function(service) {
                return service.id === queryParams.get("service");
            });
            if (serviceFromUrl.length > 0) {
                state.setService(serviceFromUrl[0]);
                state.setServiceFilter(serviceFromUrl[0]);
            }
        }
    }, [
        services
    ]);
    var resetGearboxandBody = function() {
        state.setBodyfilter({
            id: 0,
            name: ""
        });
        state.setGearboxfilter({
            id: 0,
            name: "",
            formatted_name: ""
        });
    };
    var handleBrand = function(value) {
        if (brands) {
            var brand = brands.filter(function(brand) {
                return brand.id === value;
            });
            state.setBrandFilter(brand[0]);
            state.setBrand(brand[0]);
            state.setGenerationFilter({
                id: 0,
                name: ""
            });
            state.setGeneration({
                id: 0,
                name: ""
            });
            state.setMotorizationfilter({
                id: 0,
                name: ""
            });
            state.setMotorization({
                id: 0,
                name: ""
            });
            resetGearboxandBody();
        }
    };
    var handleGeneration = function(value) {
        if (generations) {
            var generation = generations.filter(function(generation) {
                return generation.id.toString() === value;
            });
            state.setGenerationFilter(generation[0]);
            state.setGeneration(generation[0]);
            state.setMotorizationfilter({
                id: 0,
                name: ""
            });
            state.setMotorization({
                id: 0,
                name: ""
            });
            resetGearboxandBody();
        }
    };
    var handleMotorization = function(value) {
        if (motorizations) {
            var motorization = motorizations.filter(function(motorization) {
                return motorization.id.toString() === value;
            });
            state.setMotorizationfilter(motorization[0]);
            state.setMotorization(motorization[0]);
            resetGearboxandBody();
        }
    };
    var handleGearbox = function(value) {
        if (motorizations && state.filters.motorizationFilter) {
            var ref, ref1, ref2;
            var gearbox = (ref = state.filters) === null || ref === void 0 ? void 0 : (ref1 = ref.motorizationFilter) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.gearboxes) === null || ref2 === void 0 ? void 0 : ref2.filter(function(gearbox) {
                return gearbox.id.toString() === value;
            });
            if (gearbox) {
                state.setGearbox(gearbox[0]);
                state.setGearboxfilter(gearbox[0]);
            }
        }
    };
    var handleBody = function(value) {
        if (motorizations) {
            var ref, ref1, ref2;
            var body = (ref = state.filters) === null || ref === void 0 ? void 0 : (ref1 = ref.motorizationFilter) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.bodies) === null || ref2 === void 0 ? void 0 : ref2.filter(function(body) {
                return body.id.toString() === value;
            });
            if (body) {
                state.setBody(body[0]);
                state.setBodyfilter(body[0]);
            }
        }
    };
    var ref5 = useBooking(), changeDay = ref5.changeDay, daysAvailable = ref5.daysAvailable, setDaysAvailable = ref5.setDaysAvailable, setDaysLoading = ref5.setDaysLoading, nextSlot = ref5.nextSlot, selectedDay = ref5.selectedDay, isShowingServices = ref5.isShowingServices, setIsShowingServices = ref5.setIsShowingServices, selectedSlot = ref5.selectedSlot, triedSlot = ref5.triedSlot, errorWhenBlockingSlot = ref5.errorWhenBlockingSlot, loadingWhenBlockingSlot = ref5.loadingWhenBlockingSlot, selectFirstSlot = ref5.selectFirstSlot, initiallySelectedDay = ref5.initiallySelectedDay, daysLoading = ref5.daysLoading, changeSlot = ref5.changeSlot, changeEarliestSlot = ref5.changeEarliestSlot, blockSlot = ref5.blockSlot, blockedSlot = ref5.blockedSlot;
    var handleBooking = function() {
        if (!state.order.service) {
            setIsShowingServices(!isShowingServices);
        } else if (partner.shouldDisplayVehicleSelection && (!state.filters.generationFilter.id || !state.filters.motorizationFilter.id) && state.order.service && !selectedSlot) {
            toggleVehicleSelect();
        } else if (selectedSlot) {
            blockSlot(selectedSlot);
        }
    };
    (0,react.useEffect)(function() {
        if (selectedSlot && blockedSlot && blockedSlot.id) {
            // chooseSlot(blockedSlot)
            // onSubmit && onSubmit(selectedSlot)
            state.setSlot(blockedSlot);
            if (service && blockedSlot) {
                router.push({
                    pathname: "/" + partner.slug + "/buchung",
                    query: (0,_object_spread/* default */.Z)({
                        service: service.id,
                        garage: garage.id,
                        place: place && place.id != "-1" ? place.id : null,
                        slot: blockedSlot.id,
                        session: blockedSlot.session_id
                    }, (brand === null || brand === void 0 ? void 0 : brand.id) && {
                        brand: brand.id
                    }, (generation === null || generation === void 0 ? void 0 : generation.id) && {
                        generation: generation.id
                    }, (motorization === null || motorization === void 0 ? void 0 : motorization.id) && {
                        motorization: motorization.id
                    }, (gearbox === null || gearbox === void 0 ? void 0 : gearbox.id) && {
                        gearbox: gearbox.id
                    }, (body === null || body === void 0 ? void 0 : body.id) && {
                        body: body.id
                    })
                });
            }
        }
    }, [
        blockedSlot
    ]);
    (0,react.useEffect)(function() {
        // reset selected day when changing service
        changeDay(null);
        setDaysLoading(true);
    }, [
        state.order.service
    ]);
    var toggleVehicleSelect = function() {
        var status = state.isVehicleSlectionOpen;
        state.setIsVehicleSlectionOpen(!status);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: id,
        className: "garageProfile__booking col-span-full mb-4",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "h-min md:border rounded-lg md:shadow-lg relative md:sticky md:top-5 md:p-5 " + (className !== null && className !== void 0 ? className : ""),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "text-lg font-serif font-semibold mb-4",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* Text */.xv, {
                            id: "booking_headline"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "w-full flex flex-col text-sm border border-gray-300 rounded-lg px-3 py-2 my-3 cursor-pointer " + (isShowingServices ? "rounded-b-none" : ""),
                        onClick: function() {
                            return setIsShowingServices(!isShowingServices);
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-xs",
                                children: "Service"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-base text-gray-500",
                                children: state.order.service ? state.order.service.name : /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* Text */.xv, {
                                    id: "booking_select_service"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex flex-col border border-t-0 border-gray-300 max-h-[200px] overflow-y-scroll rounded-b-lg " + (isShowingServices ? "" : "hidden"),
                        children: garage.availableServices && garage.availableServices.map(function(service) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "py-2 px-3 hover:text-white hover:bg-primary-200 cursor-pointer",
                                onClick: function() {
                                    state.setService(service);
                                    setIsShowingServices(!isShowingServices);
                                },
                                children: service.name
                            }, service.id);
                        })
                    }),
                    partner.shouldDisplayVehicleSelection && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "w-full flex flex-col text-sm border border-gray-300 rounded-lg px-3 py-2 my-3 cursor-pointer ",
                        onClick: toggleVehicleSelect,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-xs",
                                children: "Fahrzeug"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-base text-gray-500",
                                children: ((ref = state.order.brand) === null || ref === void 0 ? void 0 : ref.id) !== "0" ? ((ref1 = state.order.brand) === null || ref1 === void 0 ? void 0 : ref1.name) + " " + ((ref2 = state.order.generation) === null || ref2 === void 0 ? void 0 : ref2.name) : /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* Text */.xv, {
                                    id: "booking_select_vehicle"
                                })
                            })
                        ]
                    }),
                    !state.order.service && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex md:hidden flex-col border rounded-lg text-center text-gray-500 p-8 bg-gray-100 mt-5",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                className: "fa-kit fa-calendar-arrow-up fa-fw text-gray-700 text-xl mb-3 block"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* Text */.xv, {
                                    id: partner.shouldDisplayVehicleSelection ? "booking_select_service_long_vehicle" : "booking_select_service_long"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert, {
                        display: !daysAvailable && !daysLoading,
                        title: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* Text */.xv, {
                            id: "booking_no_slots"
                        })
                    }),
                    nextSlot && garage && garage.available_days.length > 0 && selectedDay == initiallySelectedDay && /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert, {
                        display: (0,startOfDay/* default */.Z)((0,parseISO/* default */.Z)(nextSlot.starts_at)) < (0,startOfDay/* default */.Z)((0,parseISO/* default */.Z)(garage.available_days[0].available_at.toString())),
                        title: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* Text */.xv, {
                            id: "booking_error_nearest_slot_gone",
                            day: formatDate(garage.available_days[0].available_at, "dd."),
                            newDay: formatDate(nextSlot.starts_at, "dd.")
                        }),
                        duration: 10000
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert, {
                        display: !!errorWhenBlockingSlot && !!triedSlot,
                        title: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* Text */.xv, {
                                    id: "booking_slot_taken_1"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("b", {
                                    children: [
                                        "\xa0",
                                        formatDate(triedSlot ? triedSlot.starts_at : new Date(), "EEEEEE., dd.MM.yyyy 'um' HH:mm 'Uhr'")
                                    ]
                                }),
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* Text */.xv, {
                                    id: "booking_slot_taken_2"
                                })
                            ]
                        })
                    }),
                    nextSlot && /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* Text */.xv, {
                                id: "booking_next_free_slot"
                            }),
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "inline-block text-sm border rounded px-3 py-1 cursor-pointer ".concat(nextSlot === selectedSlot ? "text-white bg-primary border-primary" : "text-primary border-neutral-700"),
                                onClick: selectFirstSlot,
                                children: formatDate(nextSlot["starts_at"], "EEEEEE., dd.MM.yyyy 'um' HH:mm 'Uhr'")
                            })
                        ]
                    }),
                    (state.order.service && !selectedDay && !partner.shouldDisplayVehicleSelection || state.order.service && !selectedDay && partner.shouldDisplayVehicleSelection && brand && (motorization === null || motorization === void 0 ? void 0 : motorization.id) != 0 && (generation === null || generation === void 0 ? void 0 : generation.id) != 0) && /*#__PURE__*/ (0,jsx_runtime.jsx)(DayPicker, {
                        onChange: changeDay,
                        onNoAvailableDays: setDaysAvailable,
                        daysLoading: setDaysLoading,
                        nextSlot: nextSlot,
                        selectedDay: selectedDay
                    }),
                    selectedDay && /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "w-full flex flex-col text-sm border border-gray-300 rounded-lg px-3 py-2 my-3 cursor-pointer",
                                onClick: function() {
                                    return changeDay(null);
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: "text-xs",
                                        children: "Ausgew\xe4hlter Tag"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-base text-gray-500 rounded-lg cursor-pointer ",
                                        children: formatDate(selectedDay, "EEEEEE. dd.MM")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TimeSlotPicker, {
                                day: selectedDay,
                                selectedSlot: selectedSlot,
                                daysLoading: daysLoading,
                                onChange: changeSlot,
                                onChangeEarliestSlot: changeEarliestSlot
                            })
                        ]
                    }),
                    selectedDay && selectedSlot && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex justify-between items-center text-sm mt-5",
                        children: [
                            "Ausgew\xe4hlter Termin: ",
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "text-base text-gray-500 border border-gray-300 rounded-lg py-2 px-3",
                                children: [
                                    formatDate(selectedSlot.starts_at, "EE dd.MM"),
                                    " um ",
                                    formatDate(selectedSlot.starts_at, "HH:mm"),
                                    " Uhr"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        disabled: loadingWhenBlockingSlot || !daysAvailable,
                        className: "relative w-full bg-primary-500 px-8 py-3 mt-5 text-white rounded-lg text-center no-underline disabled:opacity-50 disabled:cursor-not-allowed",
                        onClick: handleBooking,
                        children: [
                            loadingWhenBlockingSlot && /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* Text */.xv, {
                                id: "booking_blocking"
                            }),
                            !loadingWhenBlockingSlot && /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* Text */.xv, {
                                id: "booking_submit"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition */.u, {
                show: state.isVehicleSlectionOpen,
                enter: "transition-opacity duration-300",
                enterFrom: "opacity-0 h-0",
                enterTo: "opacity-100 h-screen",
                leave: "transition-opacity duration-300",
                leaveFrom: "opacity-100 h-screen",
                leaveTo: "opacity-0 h-0",
                className: "w-screen h-screen bg-transparent left-0 bottom-0 text-black px-4 pt-20 md:pt-8 md:py-8 cursor-default z-[60] fixed",
                onClick: toggleVehicleSelect,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "bg-white h-full md:h-auto w-full pt-10 max-w-screen-md md:mx-auto md:my-0 rounded-t-md md:rounded-md overflow-auto relative text-left",
                    onClick: function(e) {
                        return e.stopPropagation();
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "vehicleFilterBlock px-8",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h4", {
                                className: "text-lg leading-6 font-serif font-medium pb-6",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "fa-kit fa-car fa-fw text-primary text-base mr-2 mr-2 inline-block"
                                    }),
                                    "Welches Fahrzeug?",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        className: "text-3xl float-right h-6 w-6 rounded-md text-black-500 right-4 top-3 absolute",
                                        onClick: toggleVehicleSelect,
                                        children: "\xd7"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "grid grid-cols-12 gap-x-2 pb-8",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "col-span-6 md:col-span-4 mb-2 relative",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectDropdown/* SelectDropdown */.F, {
                                                id: "0",
                                                placeholdertext: "Marke",
                                                values: brands,
                                                onChange: handleBrand,
                                                value: state.filters.brandFilter.id
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                className: "fa-kit fa-chevron-down fa-fw text-gray-700 text-md absolute right-4 top-[9px]"
                                            })
                                        ]
                                    }),
                                    loading && ((ref3 = state.order.brand) === null || ref3 === void 0 ? void 0 : ref3.id) != "0" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterSkeleton/* FilterSkeleton */.a, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterSkeleton/* FilterSkeleton */.a, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterSkeleton/* FilterSkeleton */.a, {})
                                        ]
                                    }),
                                    !loading && /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "col-span-6 md:col-span-4 mb-2 relative",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(GenerationSelectDropdown/* GenerationSelectDropdown */.H, {
                                                        id: "0",
                                                        placeholdertext: "Modell",
                                                        values: generations,
                                                        onChange: handleGeneration,
                                                        value: state.filters.generationFilter.id.toString()
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                        className: "fa-kit fa-chevron-down fa-fw text-gray-700 text-md absolute right-4 top-[9px]"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "col-span-6 md:col-span-4 mb-2 relative",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MotorizationSelectDropdown/* MotorizationSelectDropdown */.b, {
                                                        id: "0",
                                                        placeholdertext: "Motorisierung",
                                                        values: motorizations,
                                                        onChange: handleMotorization,
                                                        value: state.filters.motorizationFilter.id.toString()
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                        className: "fa-kit fa-chevron-down fa-fw text-gray-700 text-md absolute right-4 top-[9px]"
                                                    })
                                                ]
                                            }),
                                            state.filters.motorizationFilter.gearboxes && state.filters.motorizationFilter.gearboxes.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "col-span-6 md:col-span-4 mb-2 relative",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectDropdown/* SelectDropdown */.F, {
                                                        id: "0",
                                                        placeholdertext: "Getriebe",
                                                        values: state.filters.motorizationFilter.gearboxes,
                                                        onChange: handleGearbox,
                                                        value: state.filters.gearboxFilter.id.toString()
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                        className: "fa-kit fa-chevron-down fa-fw text-gray-700 text-md absolute right-4 top-[9px]"
                                                    })
                                                ]
                                            }),
                                            state.filters.motorizationFilter.bodies && state.filters.motorizationFilter.bodies.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "col-span-6 md:col-span-4 mb-2 relative",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectDropdown/* SelectDropdown */.F, {
                                                        id: "0",
                                                        placeholdertext: "Bauart",
                                                        values: state.filters.motorizationFilter.bodies,
                                                        onChange: handleBody,
                                                        value: state.filters.bodyFilter.id.toString()
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                        className: "fa-kit fa-chevron-down fa-fw text-gray-700 text-md absolute right-4 top-[9px]"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "buttonContainer p-4 grid grid-cols-12 gap-y-2 border-t border-black-100 bg-white md:w-full sticky bottom-0 z-20",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-span-full md:col-span-6 md:order-1 md:ml-1 rounded-md",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListButton/* ListButton */.z, {
                                            text: "apply",
                                            color: "primary-600",
                                            textcolor: "white",
                                            onClick: toggleVehicleSelect,
                                            icon: "magnifying-glass"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "col-span-full md:col-span-6 md:mr-1 border border-black-100 rounded-md",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ListButton/* ListButton */.z, {
                                            text: "cancel",
                                            color: "white",
                                            textcolor: "gray-700",
                                            onClick: toggleVehicleSelect
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
});
GarageProfileBooking.displayName = "GarageProfileBooking";


/***/ }),

/***/ 1888:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ FilterSkeleton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1438);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8029);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(460);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4463);






var FilterSkeleton = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(FilterSkeleton, PureComponent);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(FilterSkeleton);
    function FilterSkeleton() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, FilterSkeleton);
        return _super.apply(this, arguments);
    }
    var _proto = FilterSkeleton.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "w-full col-span-6 md:col-span-4 mb-2 relative",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_5__/* .Transition */ .u, {
                appear: true,
                show: true,
                enter: "transition transform duration-300 ease-out",
                enterFrom: "translate-x-4 opacity-0",
                enterTo: "translate-x-0 opacity-100",
                leave: "transition transform duration-300 ease-in",
                leaveFrom: "opacity-100",
                leaveTo: "opacity-0",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.StrictMode, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "animate-pulse col-span-6 relative appearance-none text-sm leading-5 font-medium rounded-md border border-black-200 w-full h-full px-12 py-4 mb-2 pr-6 text-gray-700"
                    })
                })
            })
        });
    };
    return FilterSkeleton;
}(react__WEBPACK_IMPORTED_MODULE_1__.PureComponent);


/***/ }),

/***/ 4449:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ GenerationSelectDropdown; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _App_store__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7576);
/* harmony import */ var _App_hooks_useDates__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6635);




var GenerationSelectDropdown = function(props) {
    var state = (0,_App_store__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    var formatDate = (0,_App_hooks_useDates__WEBPACK_IMPORTED_MODULE_3__/* .useDates */ .A)().formatDate;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("select", {
        id: props.value,
        name: props.value,
        value: props.value,
        onChange: function(e) {
            return props.onChange(e.target.value);
        },
        disabled: !props.values,
        className: "selectDropdown relative appearance-none text-sm leading-5 font-medium rounded-md border border-black-200 w-full px-4 py-2 mb-2 pr-6 text-gray-700",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                value: props.id,
                disabled: true,
                children: props.placeholdertext
            }),
            props.values && props.values.map(function(val) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                    value: val.id,
                    children: val.built_from ? val.name.split(" (")[0] + " - ab " + formatDate(val.built_from, "yyyy") : val.name
                }, val.id);
            })
        ]
    });
};


/***/ }),

/***/ 2202:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ MotorizationSelectDropdown; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _App_store__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7576);
/* harmony import */ var _App_hooks_useDates__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6635);




var MotorizationSelectDropdown = function(props) {
    var state = (0,_App_store__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    var formatDate = (0,_App_hooks_useDates__WEBPACK_IMPORTED_MODULE_3__/* .useDates */ .A)().formatDate;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("select", {
        id: props.value,
        name: props.value,
        value: props.value,
        onChange: function(e) {
            return props.onChange(e.target.value);
        },
        disabled: !props.values,
        className: "selectDropdown relative appearance-none text-sm leading-5 font-medium rounded-md border border-black-200 w-full px-4 py-2 mb-2 pr-6 text-gray-700",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                value: props.id,
                disabled: true,
                children: props.placeholdertext
            }),
            props.values && props.values.map(function(val) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                    value: val.id,
                    children: val.fuelType.name && val.ps ? val.name.split(" (")[0] + " " + val.fuelType.name + " " + val.ps + " PS" : val.name
                }, val.id);
            })
        ]
    });
};


/***/ }),

/***/ 7998:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ SelectDropdown; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _App_store__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7576);



var SelectDropdown = function(props) {
    var state = (0,_App_store__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("select", {
        id: props.value,
        name: props.value,
        value: props.value,
        onChange: function(e) {
            return props.onChange(e.target.value);
        },
        disabled: !props.values,
        className: "selectDropdown relative appearance-none text-sm leading-5 font-medium rounded-md border border-black-200 w-full px-4 py-2 mb-2 pr-6 text-gray-700",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                value: props.id,
                disabled: true,
                children: props.placeholdertext
            }),
            props.values && props.values.map(function(val) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                    value: val.id,
                    children: val.formatted_name ? val.formatted_name : val.name
                }, val.id);
            })
        ]
    });
};


/***/ }),

/***/ 5397:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ ListButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1438);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8029);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(460);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _eo_locale_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7245);






var ListButton = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(ListButton, PureComponent);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(ListButton);
    function ListButton() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(this, ListButton);
        return _super.apply(this, arguments);
    }
    var _proto = ListButton.prototype;
    _proto.render = function render() {
        var _props = this.props, text = _props.text, color = _props.color, textcolor = _props.textcolor, onClick = _props.onClick, icon = _props.icon;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "listbutton text-center text-base leading-6 font-medium md:px-2",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                className: "bg-".concat(color, " rounded-md p-2 text-").concat(textcolor, " w-full"),
                onClick: onClick,
                children: [
                    icon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                        className: "fa-kit fa-fw text-".concat(textcolor, " text-regular fa-").concat(icon, " align-middle  inline-block mr-2")
                    }),
                    " ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_eo_locale_react__WEBPACK_IMPORTED_MODULE_5__/* .Text */ .xv, {
                        id: text
                    })
                ]
            })
        });
    };
    return ListButton;
}(react__WEBPACK_IMPORTED_MODULE_1__.PureComponent);


/***/ }),

/***/ 2477:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "p": function() { return /* binding */ useVehicletree; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(1799);
// EXTERNAL MODULE: ./store.ts
var store = __webpack_require__(7576);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 10 modules
var lib = __webpack_require__(7283);
;// CONCATENATED MODULE: ./graphql/queries/getVehicletree.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    query getVehicletree($brandId: ID, $generationId: ID, $motorizationId: ID, $brandSlug: String, $generationSlug: String, $motorizationSlug: String, $includeGenerations: Boolean!, $includeMotorizations: Boolean!) {\n        brands(id: $brandId, slug: $brandSlug) {\n            id\n            name\n            logo\n            slug\n            important\n            generations(id: $generationId, slug: $generationSlug) @include(if: $includeGenerations) {\n                id\n                name\n                slug\n                built_from\n                motorizations(id: $motorizationId, slug: $motorizationSlug) @include(if: $includeMotorizations) {\n                    id\n                    name\n                    slug\n                    built_from\n                    built_to\n                    kw\n                    ps\n                    displacement\n                    bodies {\n                        id\n                        name\n                    }\n                    fuelType {\n                        id\n                        name\n                    }\n                    gearboxes {\n                        id\n                        name\n                        formatted_name\n                    }\n                }\n            }\n        }\n    }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var GET_VEHICLETREE = (0,lib/* gql */.Ps)(_templateObject());

// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useQuery.js + 1 modules
var useQuery = __webpack_require__(7887);
;// CONCATENATED MODULE: ./hooks/useVehicletree.ts




var useVehicletree = function() {
    var ref;
    var state = (0,store/* default */.Z)();
    var ref1 = (0,useQuery/* useQuery */.a)(GET_VEHICLETREE, {
        variables: (0,_object_spread/* default */.Z)({}, state.filters.brandFilter.id && {
            brandId: +state.filters.brandFilter.id
        }, state.filters.brandFilter.id != "0" && {
            includeGenerations: true
        }, state.filters.brandFilter.id == "0" && {
            includeGenerations: false
        }, state.filters.generationFilter.id != 0 && {
            includeMotorizations: true
        }, state.filters.generationFilter.id == 0 && {
            includeMotorizations: false
        })
    }), loading = ref1.loading, data = ref1.data, error = ref1.error;
    return {
        loading: loading,
        error: error,
        brands: data ? data.brands : null,
        generations: data && state.filters.brandFilter ? data.brands[0].generations : null,
        motorizations: data && state.filters.brandFilter && state.filters.generationFilter && state.filters.generationFilter.id != 0 && data.brands[0].generations ? (ref = data.brands[0].generations[0]) === null || ref === void 0 ? void 0 : ref.motorizations : null
    };
};


/***/ })

}]);